import { Component } from "@angular/core";

@Component({
  selector: "ui-separator",
  templateUrl: "./ui-separator.component.html",
  styleUrls: ["./ui-separator.component.scss"],
})
export class UiSeparatorComponent {}
